(function () {
  if (window.GBSmartAddon) return;

  const BLUE_FLAG_KEY = 'gbBlueRecommended';
  const BLUE_ELIGIBLE_PLATES_KEY = 'gbBlueEligiblePlates';
  const DEFAULT_GREEN_HANDLE = 'feinstaubplakette';
  const DEFAULT_BLUE_HANDLE = 'blaue-e-plakette-fur-elektrofahrzeuge-zugelassen-ausserhalb-deutschlands';

  const PLATE_KEY_TERMS = [
    'kennzeichen',
    'amtliches kennzeichen',
    'amtliches kenzeichen',
    'kenteken',
    'cislo licence',
    'licens nummer',
    'license plate number',
    'numero de licence',
    'targa ufficiale',
    'numer licencji',
    'license plate',
    'licence plate',
    'number plate',
    'registration number',
    'registration plate',
    'vehicle registration',
    'immatriculation',
    'plaque d immatriculation',
    'numero d immatriculation',
    'targa',
    'numero di targa',
    'numer rejestracyjny',
    'tablica rejestracyjna',
    'registracni znacka',
    'registracni cislo',
    'registreringsnummer',
    'nummerplade',
    'fahrzeugdaten ubernehmen von'
  ];

  const PROPERTY_EXCLUDE_TERMS = [
    'fahrzeugschein',
    'vehicle document',
    'registration document',
    'kentekenbewijs',
    'carte grise',
    'libretto',
    'dowod rejestracyjny',
    'technicky prukaz',
    'registreringsattest',
    'upload',
    'datenschutz',
    'privacy',
    'message',
    'nachricht',
    'checkbox',
    'bestatigen',
    'confirm',
    'hinweis'
  ];

  window.GBSmartAddon = true;

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {}
  }

  function storageRemove(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {}
  }

  function rememberAssistantRecommendation() {
    try {
      const url = new URL(window.location.href);
      if (url.searchParams.get('gb_blue_recommended') === '1') {
        storageSet(BLUE_FLAG_KEY, '1');
      }
    } catch (error) {}
  }

  function getCartJsonUrl() {
    const cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    return `${cartUrl}.js`;
  }

  async function fetchCart() {
    const response = await fetch(getCartJsonUrl(), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });

    if (!response.ok) throw new Error('Cart fetch failed');
    return response.json();
  }

  function itemHandle(item) {
    return item.handle || item.product_handle || '';
  }

  function itemTitle(item) {
    return item.product_title || item.title || '';
  }

  function getRootHandles(root) {
    return {
      green: root.dataset.greenHandle || DEFAULT_GREEN_HANDLE,
      blue: root.dataset.blueHandle || DEFAULT_BLUE_HANDLE
    };
  }

  function normalizeText(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[’'`´]/g, '')
      .replace(/[_\-–—/:]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }


  function normalizePlateIdentity(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '');
  }

  function getRememberedBlueEligiblePlates() {
    const values = [];
    try {
      const raw = storageGet(BLUE_ELIGIBLE_PLATES_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      if (Array.isArray(parsed)) values.push(...parsed);
    } catch (error) {}

    return new Set(values.map(normalizePlateIdentity).filter(Boolean));
  }

  const BLUE_ELIGIBLE_RESULT_TERMS = [
    'blau moglich',
    'blue possible',
    'blue eligible',
    'blauw mogelijk',
    'bleue possible',
    'blu possibile',
    'niebieska mozliwa',
    'modra mozna',
    'blat muligt'
  ];

  function itemHasEligibleBlueResult(item) {
    const properties = item && item.properties && typeof item.properties === 'object' ? item.properties : {};

    return Object.entries(properties).some(([key, value]) => {
      const normalizedKey = normalizeText(key);
      const normalizedValue = normalizeText(value);
      if (!normalizedKey.startsWith('rdw ')) return false;
      return BLUE_ELIGIBLE_RESULT_TERMS.some((term) => normalizedValue.includes(normalizeText(term)));
    });
  }

  function itemHasRdwResult(item) {
    const properties = item && item.properties && typeof item.properties === 'object' ? item.properties : {};
    return Object.keys(properties).some((key) => normalizeText(key).startsWith('rdw '));
  }

  function itemHasAssistantBlueEligibleMarker(item) {
    const properties = item && item.properties && typeof item.properties === 'object' ? item.properties : {};
    const value = properties._gb_blue_eligible;
    return value === 1 || value === true || /^(1|true|yes|ja)$/i.test(String(value || '').trim());
  }

  function isBlueEligibleSource(entry, rememberedPlates) {
    if (itemHasAssistantBlueEligibleMarker(entry.item)) return true;
    if (itemHasEligibleBlueResult(entry.item)) return true;
    const plateIdentity = normalizePlateIdentity(entry.plate);
    return !!(plateIdentity && rememberedPlates.has(plateIdentity));
  }

  function cleanPlate(value) {
    return String(value || '')
      .replace(/<[^>]*>/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function looksLikePlateValue(value) {
    const plate = cleanPlate(value);
    if (!plate || plate.length < 2 || plate.length > 24) return false;
    if (/^https?:\/\//i.test(plate) || /cdn\.shopify\.com/i.test(plate)) return false;
    if (/^(ja|yes|oui|si|tak|ano|b[eę]kr[aæ]ft|bitte|please)$/i.test(plate)) return false;
    if (!/[a-z0-9]/i.test(plate)) return false;
    return true;
  }

  function plateKeyScore(key) {
    const normalizedKey = normalizeText(key);
    if (!normalizedKey || normalizedKey.startsWith('_')) return -1;

    if (PROPERTY_EXCLUDE_TERMS.some((term) => normalizedKey.includes(normalizeText(term)))) {
      return -1;
    }

    let score = 0;
    PLATE_KEY_TERMS.forEach((term) => {
      const normalizedTerm = normalizeText(term);
      if (normalizedKey === normalizedTerm) score = Math.max(score, 120);
      else if (normalizedKey.includes(normalizedTerm)) score = Math.max(score, 100);
    });

    if (/plate|registr|kenteken|kennzeichen|targa|immatricul/.test(normalizedKey)) {
      score = Math.max(score, 70);
    }

    return score;
  }

  function extractPlate(item) {
    const properties = item && item.properties && typeof item.properties === 'object' ? item.properties : {};
    const candidates = [];

    Object.entries(properties).forEach(([key, value]) => {
      if (!looksLikePlateValue(value)) return;
      const score = plateKeyScore(key);
      if (score < 0) return;
      candidates.push({ score, plate: cleanPlate(value) });
    });

    candidates.sort((a, b) => b.score - a.score);
    if (candidates.length && candidates[0].score >= 70) return candidates[0].plate;

    // Sicherer Fallback für unbekannte Übersetzungen: nur kurze, nicht technische
    // Eigenschaften berücksichtigen. Bei mehreren Treffern wird nicht geraten.
    const fallback = [];
    Object.entries(properties).forEach(([key, value]) => {
      const normalizedKey = normalizeText(key);
      if (!looksLikePlateValue(value) || normalizedKey.startsWith('_')) return;
      if (PROPERTY_EXCLUDE_TERMS.some((term) => normalizedKey.includes(normalizeText(term)))) return;
      if (String(value).trim() === '1') return;
      fallback.push(cleanPlate(value));
    });

    return fallback.length === 1 ? fallback[0] : '';
  }

  function getPlatesInCartByHandles(cart, targetHandles) {
    const plates = new Set();
    (cart.items || []).forEach((item) => {
      if (!targetHandles.includes(itemHandle(item))) return;
      const plate = normalizePlateIdentity(extractPlate(item));
      if (plate) plates.add(plate);
    });
    return plates;
  }

  function getBluePlatesInCart(cart, handles) {
    return getPlatesInCartByHandles(cart, [handles.blue]);
  }

  function getGreenPlatesInCart(cart, handles) {
    return getPlatesInCartByHandles(cart, [handles.green]);
  }

  function getSourceItems(cart, offerType, handles) {
    const sourceHandle = offerType === 'green' ? handles.blue : handles.green;
    let items = (cart.items || [])
      .map((item, index) => ({
        item,
        index,
        key: item.key || `${sourceHandle}-${index}`,
        title: itemTitle(item),
        plate: extractPlate(item)
      }))
      .filter((entry) => itemHandle(entry.item) === sourceHandle);

    if (offerType === 'blue') {
      const rememberedPlates = getRememberedBlueEligiblePlates();
      const bluePlatesInCart = getBluePlatesInCart(cart, handles);
      const eligibleItems = items
        .filter((entry) => isBlueEligibleSource(entry, rememberedPlates))
        .filter((entry) => {
          const plateIdentity = normalizePlateIdentity(entry.plate);
          // Eine bereits vorhandene blaue Plakette erledigt nur die Empfehlung
          // für genau dasselbe Fahrzeug. Weitere geeignete E-Fahrzeuge bleiben offen.
          return !plateIdentity || !bluePlatesInCart.has(plateIdentity);
        });

      if (eligibleItems.length) {
        items = eligibleItems;
      } else {
        // Keine noch offene, sicher blauberechigte Fahrzeugzuordnung.
        items = [];
      }
    }

    if (offerType === 'green') {
      // Auch Blau -> Gruen wird strikt pro Kennzeichen entschieden. Eine bereits
      // vorhandene gruene Plakette fuer Fahrzeug A darf die Empfehlung fuer ein
      // anderes blaues Fahrzeug B weder ersetzen noch unterdruecken.
      const greenPlatesInCart = getGreenPlatesInCart(cart, handles);
      items = items.filter((entry) => {
        const plateIdentity = normalizePlateIdentity(entry.plate);
        return !plateIdentity || !greenPlatesInCart.has(plateIdentity);
      });
    }

    const deduplicated = [];
    const seen = new Set();

    items.forEach((entry) => {
      const dedupeKey = entry.plate ? normalizePlateIdentity(entry.plate) : entry.key;
      if (seen.has(dedupeKey)) return;
      seen.add(dedupeKey);
      deduplicated.push(entry);
    });

    return deduplicated;
  }

  function createElement(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (typeof text === 'string') element.textContent = text;
    return element;
  }

  function renderVehicleSelection(box, sources) {
    const wrapper = box.querySelector('[data-gb-smart-addon-vehicle]');
    const options = box.querySelector('[data-gb-smart-addon-vehicle-options]');
    const vehicleError = box.querySelector('[data-gb-smart-addon-vehicle-error]');
    const missingLabel = box.dataset.gbVehicleMissing || 'Kennzeichen nicht erkannt';

    if (!wrapper || !options) return;

    options.innerHTML = '';
    box.dataset.gbSourceCount = String(sources.length);
    box.dataset.gbSelectedSourceKey = '';

    if (!sources.length) {
      wrapper.hidden = false;
      const message = createElement('p', 'gb-smart-addon__vehicle-missing', box.dataset.gbVehicleNone || missingLabel);
      options.appendChild(message);
      if (vehicleError) vehicleError.hidden = true;
      return;
    }

    wrapper.hidden = false;
    const uniqueName = `gb-smart-addon-source-${Math.random().toString(36).slice(2)}`;

    sources.forEach((source, sourceIndex) => {
      const label = createElement('label', 'gb-smart-addon__vehicle-option');
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = uniqueName;
      input.value = source.key;
      input.dataset.gbSourceKey = source.key;
      input.dataset.gbSourcePlate = source.plate;
      input.dataset.gbSourceTitle = source.title;

      const textWrap = createElement('span', 'gb-smart-addon__vehicle-option-text');
      const plateText = source.plate || `${missingLabel} ${sourceIndex + 1}`;
      textWrap.appendChild(createElement('strong', '', plateText));
      if (source.title) textWrap.appendChild(createElement('small', '', source.title));

      label.appendChild(input);
      label.appendChild(textWrap);
      options.appendChild(label);

      if (sources.length === 1) {
        input.checked = true;
        box.dataset.gbSelectedSourceKey = source.key;
        label.classList.add('is-selected');
      }
    });

    wrapper.classList.toggle('gb-smart-addon__vehicle--single', sources.length === 1);
    if (vehicleError) vehicleError.hidden = true;
  }

  function configureBox(box, cart, handles) {
    const type = box.dataset.gbOffer;
    const sources = getSourceItems(cart, type, handles);
    renderVehicleSelection(box, sources);
    return sources.length;
  }

  function setOfferVisibility(root, cart) {
    const handles = getRootHandles(root);
    const hasGreen = cart.items && cart.items.some((item) => itemHandle(item) === handles.green);
    const hasBlue = cart.items && cart.items.some((item) => itemHandle(item) === handles.blue);
    const blueRecommended = storageGet(BLUE_FLAG_KEY) === '1' || getRememberedBlueEligiblePlates().size > 0;

    const blueOffer = root.querySelector('[data-gb-offer="blue"]');
    const greenOffer = root.querySelector('[data-gb-offer="green"]');

    if (blueOffer) {
      const eligibleSourceCount = configureBox(blueOffer, cart, handles);
      blueOffer.hidden = !(blueRecommended && hasGreen && eligibleSourceCount > 0);
    }

    if (greenOffer) {
      const openGreenSourceCount = configureBox(greenOffer, cart, handles);
      greenOffer.hidden = !(hasBlue && openGreenSourceCount > 0);
    }

    const hasVisibleOffer = Array.from(root.querySelectorAll('[data-gb-offer]')).some((offer) => !offer.hidden);
    root.hidden = !hasVisibleOffer;
  }

  function fallbackOfferVisibility() {
    const blueRecommended = storageGet(BLUE_FLAG_KEY) === '1';

    document.querySelectorAll('[data-gb-smart-addon]').forEach((root) => {
      let hasVisibleOffer = false;

      root.querySelectorAll('[data-gb-offer]').forEach((offer) => {
        if (offer.dataset.gbOffer === 'blue') {
          offer.hidden = !blueRecommended;
        }
        if (!offer.hidden) hasVisibleOffer = true;
      });

      root.hidden = !hasVisibleOffer;
    });
  }

  async function updateOfferVisibility() {
    const roots = document.querySelectorAll('[data-gb-smart-addon]');
    if (!roots.length) return;

    try {
      const cart = await fetchCart();
      roots.forEach((root) => setOfferVisibility(root, cart));
    } catch (error) {
      fallbackOfferVisibility();
    }
  }

  window.GBSmartAddonUpdate = updateOfferVisibility;

  function getSelectedSource(box) {
    const selected = box.querySelector('[data-gb-source-key]:checked');
    if (!selected) return null;

    return {
      key: selected.dataset.gbSourceKey || '',
      plate: selected.dataset.gbSourcePlate || '',
      title: selected.dataset.gbSourceTitle || ''
    };
  }

  function validateOffer(box) {
    const checkbox = box.querySelector('[data-gb-smart-addon-confirm]');
    const checkboxError = box.querySelector('[data-gb-smart-addon-error]');
    const vehicleError = box.querySelector('[data-gb-smart-addon-vehicle-error]');
    const source = getSelectedSource(box);

    if (!source) {
      if (vehicleError) vehicleError.hidden = false;
      const firstSource = box.querySelector('[data-gb-source-key]');
      if (firstSource) firstSource.focus();
      return false;
    }

    if (vehicleError) vehicleError.hidden = true;

    if (checkbox && !checkbox.checked) {
      if (checkboxError) checkboxError.hidden = false;
      checkbox.focus();
      return false;
    }

    if (checkboxError) checkboxError.hidden = true;
    return true;
  }

  function getSectionsForAdd() {
    const sections = ['cart-drawer', 'cart-icon-bubble'];
    const mainCartItems = document.getElementById('main-cart-items');
    const mainCartFooter = document.getElementById('main-cart-footer');

    if (mainCartItems && mainCartItems.dataset.id) sections.push(mainCartItems.dataset.id);
    if (mainCartFooter && mainCartFooter.dataset.id) sections.push(mainCartFooter.dataset.id);

    return [...new Set(sections)];
  }

  function isTransferableSourceProperty(key, value) {
    const propertyKey = String(key || '').trim();
    const stringValue = String(value || '').trim();
    if (!propertyKey || !stringValue) return false;
    if (propertyKey.startsWith('_') || /direct link/i.test(propertyKey)) return false;
    if (plateKeyScore(propertyKey) >= 70) return true;
    const normalizedKey = normalizeText(propertyKey);
    if (/^rdw\b/.test(normalizedKey)) return true;
    return /^https:\/\//i.test(stringValue) && /(shopify\.com-uploadkit\.app|getuploadkit\.com)/i.test(stringValue);
  }

  function getProperties(type, source, sourceItem) {
    const properties = {};
    const sourceProperties = sourceItem && sourceItem.properties && typeof sourceItem.properties === 'object'
      ? sourceItem.properties
      : {};

    Object.entries(sourceProperties).forEach(([key, value]) => {
      if (isTransferableSourceProperty(key, value)) properties[key] = value;
    });

    return properties;
  }

  function renderCartDrawer(state) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || !state || !state.sections || !state.sections['cart-drawer']) return false;

    if (typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(state);
      setTimeout(updateOfferVisibility, 80);
      return true;
    }

    return false;
  }

  function updateCartIcon(state) {
    if (!state || !state.sections || !state.sections['cart-icon-bubble']) return;

    const target = document.getElementById('cart-icon-bubble');
    const source = new DOMParser()
      .parseFromString(state.sections['cart-icon-bubble'], 'text/html')
      .getElementById('cart-icon-bubble');

    if (target && source) target.innerHTML = source.innerHTML;
  }

  async function addAddonProduct(button) {
    const box = button.closest('[data-gb-smart-addon-box]');
    if (!box || !validateOffer(box)) return;

    const variantId = Number(button.dataset.variantId);
    const type = button.dataset.gbOfferType;
    const source = getSelectedSource(box);
    const originalText = button.textContent;
    const startedInCartNotification = !!button.closest('cart-notification');

    if (!variantId || !type || !source) return;

    button.disabled = true;
    button.textContent = button.dataset.loadingText || originalText;

    try {
      let sourceItem = null;
      try {
        const currentCart = await fetchCart();
        sourceItem = (currentCart.items || []).find((item) => item.key === source.key) || null;
      } catch (error) {}

      const response = await fetch(window.routes.cart_add_url, {
        ...fetchConfig('javascript'),
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: getProperties(type, source, sourceItem)
            }
          ],
          sections: getSectionsForAdd(),
          sections_url: window.location.pathname
        })
      });

      if (!response.ok) throw new Error('Cart add failed');

      const state = await response.json();
      // Nicht global löschen: Bei mehreren E-Fahrzeugen können weitere
      // kennzeichenbezogene blaue Empfehlungen noch offen sein.
      if (type !== 'blue') storageRemove(BLUE_FLAG_KEY);

      if (window.location.pathname.indexOf('/cart') !== -1 || startedInCartNotification) {
        window.location.href = window.routes.cart_url;
        return;
      }

      updateCartIcon(state);

      if (!renderCartDrawer(state)) {
        window.location.href = window.routes.cart_url;
      }
    } catch (error) {
      console.error(error);
      button.disabled = false;
      button.textContent = originalText;
      const boxError = box.querySelector('[data-gb-smart-addon-error]');
      if (boxError) {
        boxError.textContent = 'Das Zusatzprodukt konnte nicht hinzugefügt werden. Bitte versuchen Sie es erneut.';
        boxError.hidden = false;
      }
    }
  }

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-gb-source-key]')) {
      const box = event.target.closest('[data-gb-smart-addon-box]');
      if (!box) return;

      box.querySelectorAll('.gb-smart-addon__vehicle-option').forEach((option) => {
        const radio = option.querySelector('[data-gb-source-key]');
        option.classList.toggle('is-selected', !!(radio && radio.checked));
      });

      const vehicleError = box.querySelector('[data-gb-smart-addon-vehicle-error]');
      if (vehicleError) vehicleError.hidden = true;
      return;
    }

    if (!event.target.matches('[data-gb-smart-addon-confirm]')) return;
    const box = event.target.closest('[data-gb-smart-addon-box]');
    const error = box && box.querySelector('[data-gb-smart-addon-error]');
    if (error && event.target.checked) error.hidden = true;
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-gb-smart-addon-add]');
    if (!button) return;
    event.preventDefault();
    addAddonProduct(button);
  });

  document.addEventListener('DOMContentLoaded', () => {
    rememberAssistantRecommendation();
    updateOfferVisibility();
  });

  document.addEventListener('shopify:section:load', updateOfferVisibility);
})();
